import React from "react";

import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../../../components/common/InputField";
import TextareaField from "../../../components/common/TextareaField";
import SelectElement from "../../../components/common/SelectElement";
import SendButton from "../../../components/common/Button";

// Scss imports
import css from "./OutgoingDocumentsForm.module.scss";

interface OutgoingDocumentsFormProps {
  categoryListArray: any;
  onSelectChange: Function;
  baseNumber: number | string;
  recipientValue: string;
  setRecipientValue?: any;
  onRecipientInputValueChange: Function;
  suggestions?: string[] | undefined;
  setSuggestions: Function;
  usersRecipients: any;
  nationalIdValue?: string | number;
  documentNumberValue?: string;
  subnumber: string;
  shortText: string;
  processor: string;
  sendOutgoingDocument: any;
  userProcessors: any;
  onProcessorInputValueChange: Function;
  suggestionsProcessor?: string[] | undefined;
  setProcessor: any;
  disabledButton: boolean;
  onNationalIdInputValueChange: Function;
  onDocumentNumberInputValueChange: Function;
  onShortTextValueChange: Function;
  inputNationalIdError?: string;
  inputDocumentNumberError?: string;
  inputRecipientError?: string;
  inputProcessorError?: string;
  inputShortTextError?: string;
  inputCategoryError?: string;
  onProcessorSelectChange: Function;
  recipientSenderName: string;
  incomingDocument?: boolean;
  setNationalIdValue: any;
  remark: string;
  onRemarkValueChange: Function;
  inputRemarkError: string;
  senderDateValue: string;
  onSenderDateInputValueChange: Function;
  inputSenderDateError: string;
}

const OutgoingDocumentsForm: React.FC<OutgoingDocumentsFormProps> = ({
  categoryListArray,
  onSelectChange,
  baseNumber,
  recipientValue,
  setRecipientValue,
  onRecipientInputValueChange,
  suggestions,
  usersRecipients,
  nationalIdValue,
  documentNumberValue,
  setNationalIdValue,
  subnumber,
  shortText,
  processor,
  sendOutgoingDocument,
  userProcessors,
  onProcessorInputValueChange,
  suggestionsProcessor,
  setProcessor,
  disabledButton,
  onNationalIdInputValueChange,
  onDocumentNumberInputValueChange,
  onShortTextValueChange,
  inputNationalIdError,
  inputDocumentNumberError,
  inputRecipientError,
  inputProcessorError,
  inputShortTextError,
  inputCategoryError,
  onProcessorSelectChange,
  recipientSenderName,
  incomingDocument,
  remark,
  onRemarkValueChange,
  inputRemarkError,
  senderDateValue,
  onSenderDateInputValueChange,
  inputSenderDateError,
  setSuggestions,
}) => {
  const history = useHistory();
  return (
    <div className={css.container}>
      <form>
        <div className={css.formGroupWrapper}>
          <div className={css.selectInput}>
            <SelectElement
              label="Основни број"
              id="category"
              name="category"
              handleChange={(e) => onSelectChange(e)}
              selectOptionsArray={categoryListArray}
              rowFormGroup={true}
              minLabelWidth={true}
              errorTextColumn={inputCategoryError}
            />
            <InputField
              label=""
              name="baseNumber"
              id="baseNumber"
              type="number"
              value={baseNumber}
              placeholder=""
              //value={baseNumber}
              //handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) => (e.target.placeholder = "483483")}
              rowFormGroup={true}
              disabled={true}
              inputType="filterInput"
              //errorText={errorBaseNumberText}
              //onInputHandler={onInputBaseNumber}
            />
          </div>
        </div>
        <div className={css.formGroupWrapper}>
          <InputField
            label="Подброј"
            name="subnumber"
            id="subnumber"
            type="number"
            readOnly={true}
            value={subnumber}
            //handleChange={handleChange}
            rowFormGroup={true}
            minLabelWidth={true}
            //errorText={errorSubnumberText}
            //onInputHandler={onInputSubnumber}
          />
        </div>
        <div className={css.formGroupWrapper}>
          <TextareaField
            label="Кратак садржај"
            name="shortText"
            id="shortText"
            placeholder="Унеси кратак садржај"
            value={shortText}
            handleChange={onShortTextValueChange}
            handleOnFocus={(e: any) => (e.target.placeholder = "")}
            handleOnBlur={(e: any) =>
              (e.target.placeholder = "Унеси кратак садржај")
            }
            rowFormGroup={true}
            minLabelWidth={true}
            errorTextColumn={inputShortTextError}
            //errorText={errorShortTextText}
            //onInputHandler={onInputShortText}
          />
        </div>
        <div className={css.formGroupWrapper}>
          <InputField
            label={recipientSenderName}
            name="recipient"
            id="recipient"
            type="recipient"
            placeholder="Дејан Јовановић"
            value={recipientValue}
            handleChange={onRecipientInputValueChange}
            handleOnFocus={(e: any) => (e.target.placeholder = "")}
            handleOnBlur={(e: any) =>
              (e.target.placeholder = "Дејан Јовановић")
            }
            rowFormGroup={true}
            minLabelWidth={true}
            errorTextColumn={inputRecipientError}
            //errorText={errorBaseNumberText}
            //onInputHandler={onInputBaseNumber}
            suggestions={suggestions}
            setSuggestions={setSuggestions}
            inputType="autosuggestionRecipient"
            setRecipientValue={setRecipientValue}
            users={usersRecipients}
            setNationalIdValue={setNationalIdValue}
          />
        </div>
        {/*<div className={css.formGroupWrapper}>
          <InputField
            label="Матични број пошиљаоца"
            name="nationalId"
            id="nationalId"
            type="nationalId"
            placeholder="4834834343434"
            value={nationalIdValue}
            setNationalIdValue={setNationalIdValue}
            handleChange={onNationalIdInputValueChange}
            handleOnFocus={(e: any) => (e.target.placeholder = "")}
            handleOnBlur={(e: any) => (e.target.placeholder = "483483343434")}
            rowFormGroup={true}
            minLabelWidth={true}
            errorTextColumn={inputNationalIdError}
            //errorText={errorNationalIdText}
            //onInputHandler={onInputNationalId}
          />
          </div>*/}
        {incomingDocument && (
          <div className={css.formGroupWrapper}>
            <InputField
              label="Број документа пошиљаоца"
              name="documentNumber"
              id="documentNumber"
              type="string"
              placeholder="1"
              value={documentNumberValue}
              handleChange={onDocumentNumberInputValueChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) => (e.target.placeholder = "483483343434")}
              rowFormGroup={true}
              minLabelWidth={true}
              errorTextColumn={inputDocumentNumberError}
              //errorText={errorDocumentNumberText}
              //onInputHandler={onInputDocumentNumber}
            />
          </div>
        )}
        {incomingDocument && (
          <div className={css.formGroupWrapper}>
            <InputField
              label="Датум документа пошиљаоца"
              name="senderDate"
              id="senderDate"
              type="date"
              value={senderDateValue}
              handleChange={onSenderDateInputValueChange}
              rowFormGroup={true}
              minLabelWidth={true}
              errorTextColumn={inputSenderDateError}
              //errorText={errorDocumentNumberText}
              //onInputHandler={onInputDocumentNumber}
            />
          </div>
        )}
        {/*<InputField
          label="Обрађивач"
          name="processor"
          id="processor"
          type="processor"
          placeholder="Jovana Lukić"
          value={processor}
          //handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "483483343434")}
          rowFormGroup={true}
          minLabelWidth={true}
          users={userProcessors}
          inputType="autosuggestionProccesor"
          suggestions={suggestionsProcessor}
          handleChange={onProcessorInputValueChange}
          setRecipientValue={setProcessor}
          errorTextColumn={inputProcessorError}
          //errorText={errorProcessorText}
          //onInputHandler={onInputProcessor}
				/>*/}

        {userProcessors.length > 1 ? (
          <div className={css.formGroupWrapper}>
            <SelectElement
              label="Обрађивач"
              id="processors"
              name="processors"
              handleChange={(e) => onProcessorSelectChange(e)}
              selectOptionsArray={userProcessors}
              rowFormGroup={true}
              minLabelWidth={true}
              errorTextColumn={inputProcessorError}
            />
          </div>
        ) : (
          <div className={css.parentProcessors}>
            <p className={css.processorsText}>
              Прво унесите обрађиваче да бисте креирали документ
            </p>
            <button
              onClick={() => history.push("/processors")}
              className={css.processorsButton}
            >
              Унесите обрађиваче
            </button>
          </div>
        )}

        {/* Remark element */}
        <div className={css.formGroupWrapper}>
          <TextareaField
            label="Напомена"
            name="remark"
            id="remark"
            placeholder="Унеси напомену"
            value={remark}
            handleChange={onRemarkValueChange}
            handleOnFocus={(e: any) => (e.target.placeholder = "")}
            handleOnBlur={(e: any) => (e.target.placeholder = "Унеси напомену")}
            rowFormGroup={true}
            minLabelWidth={true}
            errorTextColumn={inputRemarkError}
            //errorText={errorShortTextText}
            //onInputHandler={onInputShortText}
          />
        </div>

        {/* Send button */}
        <div className={css.sendButtonWrapper}>
          <SendButton
            text="Креирај документ"
            onButtonClickHandler={sendOutgoingDocument}
            disabledButton={disabledButton}
          />
        </div>
      </form>
    </div>
  );
};

export default OutgoingDocumentsForm;
